export default {
   "Search": "Search",
   'User': 'User',
   "Users": "Users",
   "Email": "Email",
   "Phone Number": "Phone Number",
   "Address": "Address",
   "Company login": "Company login",
   "Permission" : "Permission",
   "All Users" : "All Users",
   "Loading Course Data..." : "Loading Course Data...",
   "Send Message to Group/Users" : "Send Message to Group/Users",
  /***************** Sidebar *********/
    " 'Continue Learning' : 'Continue Learning',": "   'Continue Learning' : 'Continue Learning',",
 /****************** Navbar *************/
    "Logout": "Logout",
    "Profile": "Profile",
    "Invoices":"Invoices",
 /****************** Dashboard Datatable ***********/
   "Title": "Title",
   "Version": "Version",
   "Module Slug": "Module Slug",
   "Progress": "Progress",
   "Attempted on": "Attempted on",
   "Score":"Score",
   "Your Quizes":"Your Quizes",
   "Your Modules": "Your Modules",
   "Launch":"Launch",
   "Jump To Quiz": "Jump To Quiz",
   "Rows per page": "Rows per page",
   "There is no Quiz to show" : "There is no Quiz to show",
   "There is no Data to show" : "There is no Data to show",

 /****************** Users ***********/
    "Name": "Name",
    "Actions": "Actions",
    "Image" : "Image",
    "Salutation": "Salutation",
    "Invite Users": "Invite Users",
    "Date of Birth": "Date of Birth",
    "All cards": "All cards",
    "Card added successfully":"Card added successfully",
    "Remove" :"Remove",
    "User Profile": "User Profile",
    "All Cards": "All Cards",
    "Add Card" : "ADD CARD",
    "Primary": "Primary",
    "Are you sure want to remove?": "Are you sure want to remove?",
    "Subscribe" : "Subscribe",
    "Are you sure you want to purchase?": "Are you sure you want to purchase?",
    "Yes":"Yes",
    "No":"No",
    "You dont seem to have a card added to your profile":"You dont seem to have a card added to your profile",
    "Go to profile": "Go to profile",
   "Place of birth": "Place of birth",
   "Allow registration" : "Allow registration",
   "Allowed Email Domains" : "Allowed Email Domains",
   "No data to show" : "No data to show",
/****************** Courses ***********/
   "Subscribed Courses" : "Subscribed Courses",
   "Un-Subscribed Courses" : "Un-Subscribed Courses",

   "Filters":"Filters",
   "Details": "Details",
   "Purchased": "Purchased",
   "Included" : "Included",
   "What Will you Learn?": "What Will you Learn?",
   "Requirements" : "Requirements",
   "Glossary" : "Glossary",
   'Description' : 'Description',
   "PLAY NOW": "PLAY NOW",
   'Language': "Language",
   "Created On:" : "Created On:",
   "Course Subscription Ends On:" : "Course Subscription Ends On:",


    "Contact us": "Contact us",
    "Module": "Module",
    "Modules": "Modules",
    "Subject": "Subject",
    "Body": "Body",
    "Send copy to myself" : "Send copy to myself",
    "Status": "Status",
    "Join date": "Join date",
    'Last login' : 'Last login',
    "Change status": "Change status",
    "Active": "Active",
    "Inactive":"Inactive",
    "active": "Active",
    "inactive":"Inactive",
    "Pending": "pending",
    "disable": "Disable",
    "pending": "Pending",
    "Subscribed":"Subscribed",
    "Unsubscribed":"Unsubscribed",
    "English":"English",
    "German":"German",
    "User updated successfully": "User updated successfully",
    "User created successfully": "User created successfully",
    "Learning material": "Learning material",
    "Learning": "Learning",
    'No modules found': 'No modules found',
    'Course': 'Course',
    'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
    'Your attempted modules': 'Your attempted modules',
    'No data found': 'No data found',
    'Search learning material': 'Search learning material',
    'Time Spent' : 'Time Spent',
    'From': 'From',
    'To': 'To',
    'Play':'Play',
    'Your sessions': 'Your sessions',
    'Your attempts': 'Your attempts',
    'Inbox': 'Inbox',
    'Board': 'Board',
    'Settings': 'Settings',
    'View': 'View',
    'Roles': 'Roles',
    'Group': 'Groups',
    'Comment (optional)': 'Comment (optional)',
    'Due date':'Due date',
    'Select file': 'Select file',
    'User document name':'User document name',
    'Days until': 'Days until',
    'Template' : 'Template',
    'Update': 'Update',    
    'Edit': 'Edit',
    'Uploaded by': 'Uploaded by',
    'Uploaded on': 'Uploaded on',
    'Type':'Type',
    'Action':'Action',
    'Stage 1': 'Stage 1',
    'Stage 2': 'Stage 2',
    'Set Name': 'Set Name',
    'Show next': 'Show next',
    'Show from':'Show from',
    'Name is required': 'Name is required',
    'Invalid Email address': 'Invalid Email address',
    'Phone Number is required': 'Phone Number is required',
    'Disable user?: Yes' : 'Disable user? Yes',
    'Disable user?: No' : 'Disable user? No',
    'Disable from' : 'Disable from',
    'Salutation is required':'Salutation is required',
    'Address is required': 'Address is required',
    'Group admin is required':'Group admin is required',
    'Groups are required': 'Groups are required',
    'Status is required': 'Status is required',
    'Date is required': 'Date is required',
    'Mr': 'Mr',
    'Mrs':'Mrs',
    'Create learning material':'Create learning material',
    'Set Filter':'Set Filter',
    'Location':'Location',
    'Procedure': 'Procedure',
    'Class':'Class',
    'Maker':'Maker',
    'Serial maker': 'Serial maker',
    'Stock':'Stock',
    'Good until date': 'Good until date',
    'Equipment':'Equipment',
    'Number in stock': 'Number in stock',
    'Serial number':'Serial number',
    'Location is required':'Location is required',
    'Class is required':'Class is required',
    'Maker is required': 'Maker is required',
    'Number in stock is required':'Number in stock is required',
    'Goods until date is required': 'Goods until date is required',
    'Procedure is required':'Procedure is required',
    ' is required':' is required',
    'Equipment created successfully':'Equipment created successfully',
    'Equipment updated successfully':'Equipment updated successfully',
   'Group name': 'Group name',
    'Group admins': 'Group admins',
    'Group name is required':'Group name is required',
    'Users are required': 'Users are required',
    'Course are required':'Course are required',
    'Learning material are required':'Learning material are required',
    'Company settings': 'Company settings',
    'Company Color': 'Company Color',
    'Session login time': 'Session login time',
    'Select TimeZone' : 'Select TimeZone',
    'Please Select Timezone for the Company' : 'Please Select Timezone for the Company',
    'Daily Quiz Settings' : "Daily Quiz Settings",
    'Number of Questions' : 'Number of Questions',
    'Passing Percentage' : 'Passing Percentage',
    'America/Chicago' : 'America/Chicago',
    'Europe/Berlin' : 'Europe/Berlin',
    'Asia/Kolkata' : 'Asia/Kolkata',
    'Quiz Score History' : 'Quiz Score History',

    'Primary color is required':'Primary color is required',
    'Company settings updated successfully':'Company settings updated successfully',
    'Intellectual Property Rights': 'Intellectual Property Rights',
    'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.',
    'I accept this (required)': 'I accept this (required)',
    'Please subscribe to a course':'Please subscribe to a course',
    'Your score': 'Your score',
    'Max Score' : 'Max Score',
    'Time taken':'Time taken',
    'Pass Score':'Pass Score',
    'Confirm password': 'Confirm password',
    'No subscribed courses found':'No subscribed courses found',
    'Role is required':'Role is required',
    'Confirm Password is required': 'Confirm Password is required',
    'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_',
    'Password must be at least 8 characters long': 'Password must be at least 8 characters long',
    'Confirm Password must be at least 8 characters long' : 'Confirm Password must be at least 8 characters long',
    'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_',
    'Query successfully sent': 'Query successfully sent',
    'Dashboard': 'Dashboard',
    "Courses": "Courses",
    "Check":"Check",
    "Clear": "Clear",
    'No data available': 'No data available',
    'Company color': 'Company color',
    'Update Password': 'Update Password',
    'This password reset token is invalid': 'This password reset token is invalid',
    'Password is required':'Password is required',
    'Accept & Continue':'Accept & Continue',
    'Due days is required':'Due days is required',
    'Learn NDT': 'Learn NDT',
    'Username': 'Username',
    'Password': 'Password',
    'Forgot password': 'Forgot password',
    'Register':'Register',
    'Login':'Login',
    'Username is required': 'Username is required',
    'Phone is required':'Phone is required',
    'User registeration successfully':'User registeration successfully',
    'Company Admin Login': 'Company Admin Login',
    'Go to Login': 'Go to Login',
    'Send link':'Send link',
    'No user documents':'No user documents',
    'User documents':'User documents',
    'Update user documents' : 'Update user documents',
    'Edit user documents': 'Edit user documents',
    'Module details': 'Module details',
    'passed':'Passed',
    'Passed':'Passed',
    'attempted': 'Attempted',
    'Attempted': 'Attempted',
    'Progress & Attempts': 'Progress & Attempts',
    'failed':'Failed',
    'of': 'of',
    'Details new': 'Details',
    'Passwords must match':'Passwords must match',
    'Save': 'Save',
    'Profile updated successfully': 'Profile updated successfully',
    'Group created successfully': 'Group created successfully',
    'Group updated successfully': 'Group updated successfully',
    'User document updated successfully': 'User document updated successfully',
    'Registration status changed successfully': 'Registration status changed successfully',
    'Write to Company Representative': 'Write to Company Representative',
    'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here': 'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here',
    'No Learning material found':'No Learning material found',
    'OK':'OK',
    'Cancel': 'Cancel',
    'Body is required':'Body is required',
    'Subject is required':'Subject is required',
    'Undefined':'Undefined',
    'Copyright legal notice':'Copyright legal notice',
    'Close':'Close',
    'Please upload a file':'Please upload a file',
    'The value must be an integer number':'The value must be an integer number',
    'Session minutes is required':'Session minutes is required',
    '& others':'& others',
    'Continue': 'Continue',
    'All':'All',
    'Reset your Password':'Reset your Password',
    'Group id': 'Group id',
    'Go to courses':'Go to courses',
    'Check all': 'Check all',
    'Uncheck all' : 'Uncheck all',
    'Not subscribed': 'Not subscribed',
    'Reset':'Reset',
    'dashboardstats': 'Showing {users} {userstat} and {courses} {coursesstat} ',
    'Reminder': 'Reminder',
    'Reminder email': 'Reminder email',
    'Email timespan': 'Email timespan',
    "Email timespan is required" : "Email timespan is required",
    'Reminder created successfully' : 'Reminder created successfully',
    'Reminder updated successfully' : 'Reminder updated successfully',

    'Equipment Group':'Equipment Group',
    'Add Equipment Group': 'Add Equipment Group',
    'Edit Equipment Group':'Edit Equipment Group',
    'Equipment group name': 'Equipment group name',
    'Equipment group name is required': 'Equipment group name is required',
    'Equipment group added successfully': 'Equipment group added successfully',
    'Equipment group updated successfully': 'Equipment group updated successfully',
    'User Group': 'User Group',
    'Equipment Template':'Equipment Template',
    'Equipment template id': 'Equipment template id',
    'Equipment templates':'Equipment templates',
    'Equipment template added successfully': 'Equipment template added successfully',
    'Equipment template updated successfully':'Equipment template updated successfully', 
    'Company Admin' : 'Company Admin',
    'Tester' : 'Tester',
    'Auditor' : 'Auditor',
    'External User' : 'External User',
    'user' : 'User',
    'group-admin' : 'Group Admin',
    'company-admin' : 'Company Admin',
    'external-user' : 'External User',
    'tester' : 'Tester',
      
    "UserInvitationMail" : "UserInvitationMail (Sends invitation mail to user)",
    "ExternalUserInvitationMail"  : "ExternalUserInvitationMail (Sends invitation mail to external user)",
    "ContactUsMail" : "ContactUsMail (Sends a direct message to user)",
    "ContactUsSendCopyMail" : "ContactUsSendCopyMail (Sends a copy of direct message to oneself)",
    "DailyStatsMail" : "DailyStatsMail (Daily statistics mail)",
    "InstructorBookingMail" : "InstructorBookingMail (Booking mail for an instructor)",
    "UserBookingMail" : "UserBookingMail (Confirmation mail of booking to a user)",
    "UserInvitationCourseCouponCodeMail" : "UserInvitationCourseCouponCodeMail (User invitaion mail along with course coupon code)",
    "UserInvitationTutorProductCouponCodeMail" : "UserInvitationTutorProductCouponCodeMail (User invitaion mail along with coupon code for tutor products)",
    "CourseCouponCodeMail" : "CourseCouponCodeMail (Mail with course coupon code)",
    "CourseCertificateMail" : "CourseCertificateMail (Sends course certificate mail to user)",
    "TutorProductCouponCodeMail" : "TutorProductCouponCodeMail (Mail with tutor product coupon code)",
    "TwoFactorAuthCodeMail" : "TwoFactorAuthCodeMail (Two factor authentication mail to users)",
    "PasswordResetRequestMail" : "PasswordResetRequestMail (Password reset mail)",
    "PasswordResetSuccessMail": "PasswordResetSuccessMail (Success mail for password resets)",

    'Add Equipment Template': 'Add Equipment Template',
    'Edit Equipment Template': 'Edit Equipment Template',
    'Equipment template': 'Equipment template',
    'Equipment template is required': 'Equipment template is required',
    'Equipment template name':'Equipment template name',     
    'Validity':'Validity',
    'Template name':'Template name',
    'Select template':'Select template',
    'Template name is required':'Template name is required',
    'Validity is required':'Validity is required',
    'Template file is required':'Template file is required',
    'Equipment Groups':'Equipment Groups',
    'Personal Template':'Personal Template',
    'Add Personal document':'Add Personal document',
    'Edit Personal document': 'Edit Personal document',
    'Personal template name': 'Personal template name',
    'Personal Templates':'Personal Templates',
    'Upload date':'Upload date',
    'Personal template name is required': 'Personal template name is required',
    'Personal template added successfully': 'Personal template added successfully',
    'Personal template updated successfully':'Personal template updated successfully',
    'Test case group id': 'Test case group id',
    'Test case group name': 'Test case group name',
    'Test case group name is required':'Test case group name is required',
    'Test case group added successfully':'Test case group added successfully',
    'Test case group updated successfully':'Test case group updated successfully',
    'Add Test Case Group':'Add Test Case Group',
    'Edit Test Case Group':'Edit Test Case Group',
    'Test case template id': 'Test case template id',
    'Test Case':'Test Case',
    'Items': 'Items',
    'All Groups':'All Groups',
    'Inventory number': 'Inventory number',
    'Test Case Template': 'Test Case Template',
    'Test Case Group': 'Test Case Group',     
    'Equipment groups':'Equipment groups',     
    'Equipment name':'Equipment name',
    'Add Items':'Add Items',
    'Edit Items':'Edit Items',
    'Equipment name is required':'Equipment name is required',
    'Equipment group is required': 'Equipment group is required', 
    'Serial number is required': 'Serial number is required',
    'Test case template name':'Test case template name',
    'Test case template': 'Test case template',
    'Test case group':'Test case group',
    'Category': 'Category',
    'Add category': 'Add Category',
    'Add': 'Add',
    'Validity type':'Validity type',
    'One time':'One time',
    'Recurring': 'Recurring',
    'Task Center':'Task Center',
    'Task Template': 'Task Template',
    'Tasks':'Tasks',
    'Task Group':'Task Group',
    'Equipment image':'Equipment image',
    'Operational status':'Operational status',
    'Operational status is required':'Operational status is required',
    'Not operational': 'Not operational',
    'Operational':'Operational',

    'Update document': 'Update document',
    'Create document':'Create document',
    'Task template id': 'Task template id',
    'Add Task template': 'Add Task template',
    'Edit Task template':'Edit Task template',
    'Task template name': 'Task template name',
    'Task templates': 'Task templates',
    'Task id': 'Task id',
    'Validity type is required': 'Validity type is required',
    'Task template added successfully': 'Task template added successfully',
    'Task template updated successfully': 'Task template updated successfully',
    'Add Task': 'Add Task',
    'Edit Task': 'Edit Task',
    'Task name':'Task name',
    'Task template': 'Task template',
    'Edit Task document': 'Edit Task document',
    'Update Task document':'Update Task document',
    'Task template are required': 'Task template are required',
    'Task  is required': 'Task  is required',
    'Task document updated successfully': 'Task document updated successfully',
    'Task added successfully' : 'Task added successfully',
    'Task updated successfully' : 'Task updated successfully',
    'Task name is required' : 'Task name is required',
    'Task group id': 'Task group id',
    'Add Task Group': 'Add Task Group',
    'Edit Task Group': 'Edit Task Group',
    'Task group name': 'Task group name',
    'Task group name is required': 'Task group name is required',
    'Task group added successfully' : 'Task group added successfully',
    'Task group updated successfully' : 'Task group updated successfully',
    'Personal templates':'Personal templates',
    'Task group':'Task group',
    'Setup Items': 'Setup Items',
    'Items Board':'Items Board',
    'Video': 'Video',
    'Remove out from Inbox': 'Remove out from Inbox',
    'Update Calibration document': 'Update Calibration document',
    'Certifications': 'Certifications',
    'Course name':'Course name',
    'Completed on':'Completed on',
    'Title is required' : 'Title is required',
    'Title must be less than 4 characters': 'Title must be less than 4 characters',
    'Is External Group':'Is External Group',
    'External Users':'External Users',
    'Label is required': 'Label is required',
    'Label types': 'Label types',
    'Label type is required' : 'Label type is required',
    'Add custom label': 'Add custom label',
    'Add document': 'Add document',
    'Add equipment template' : 'Add equipment template',
    'Edit equipment template': 'Edit equipment template',
    'Add template': 'Add template',
    'Edit template': 'Edit template',
    'Template is required': 'Template is required',
    'Label': 'Label',
    'Add label':'Add label',
    'File form': 'File form',
    'Custom Form': 'Custom form',
    'Please fill custom form or file form completely': 'Please fill custom form or file form completely',
    'Field is required': 'Field is required',
    'File is required': 'File is required',
    'View Template': 'View Template',
    'Is External User':'Is External User',
   'Vouchers': 'Vouchers',
   'Order': 'Order',
   'Voucher Purchased Successfully': 'Voucher Purchased Successfully',
   'Coupons': 'Coupons',
   'View Coupons': 'View Coupons',
   'Send Coupons': 'Send Coupons',
   'Sent To': 'Sent To',
   'Redeemed': 'Redeemed',
   'Revoke': 'Revoke',
   'Vouchers Available to Send': 'Vouchers Available to Send',
   'UsersAdd': 'Users',
   'Emails': 'Emails',
   'GroupsAdd': 'Groups',
   
   'Buy Vouchers' : 'Buy Vouchers',
   'Manage Vouchers' : 'Manage Vouchers',
   'User Groups' : 'User Groups',
   'Email Ids' : 'Email Ids',
   'unused' : 'unused',
   'used' : 'used',
   'revoked': 'revoked',
   'Are you sure want to Revoke the Coupon?' : 'Are you sure want to Revoke the Coupon?',
   'Order Purchase Confirmation' : 'Order Purchase Confirmation',
   'Order Summary' : 'Order Summary',
   'Subtotal' : 'Subtotal',
   'Coupon Code' : 'Coupon Code',
   'Total' : 'Total',
   'Apply' : 'Apply',
   'I agree' : 'I have read and agree to the website',
   'terms': '[terms]',
   'Pay securely using' : 'Pay securely using',
   'Send To':  'Send To',
   'Need to change payment method?':  'Need to change payment method?',
   'Thank you for Subscribing' : 'Thank you for Subscribing',
   'You can find subscribed courses in your Dashboard' : 'You can find subscribed courses in your Dashboard',
   'Go to Dashboard':  'Go to Dashboard',
   'Coupon Code Sent Successfully!': 'Coupon Code Sent Successfully!',
   'Some Problem occurred!': 'Some Problem occurred!',
   'Invalid Coupon Code':'Invalid Coupon Code',
   'Coupon applied Successfully':'Coupon applied SUCCESSFULLY',
   'Limit reached':'Limit reached',
   'Number of Vouchers': 'Number of Vouchers',
   'Buy Course Vouchers': 'Buy Course Vouchers',
   'Manage Course Vouchers': 'Manage Course Vouchers',
   'Buy Tutor Vouchers': 'Buy Tutor Vouchers',
   'Manage Tutor Vouchers': 'Manage Tutor Vouchers',
   'Book a Tutor': 'Book a tutor',
   'No Tutor Products to display': 'No Tutor Products to display',
   'Tutor Products Available': 'Tutor Products Available',
   'Book': 'Book',
   'Pick another': 'Pick another',
   'Booking Complete': 'Booking Complete',
   'Please check you email for further details.': 'Please check you email for further details.',
   'Book Again' : 'Book Again',
   'No User Groups assigned to this Course': 'No User Groups assigned to this Course',
   'Login with Office' : 'Login with Office',
   'Oops there was an error.' : 'Oops there was an error.',
   'Please contact Administrator.' : 'Please contact Administrator.',
   'Redirecting...' : 'Redirecting...',
   'Complete Your Personal Info' : 'Complete Your Personal Info',
   'Please provide your personal information. All Details are mandatory and will appear in your certificate as shown below.':'Please provide your personal information. All Details are mandatory and will appear in your certificate as shown below.',
   'Personal Info' : 'Personal Info',


   'Question': 'Question',
   'Questions': 'Questions',
   'Add Question' : 'Add Question',
   'Edit Question' : 'Edit Question',
   'Question id' : 'Question id',
   'Question name is required' : 'Question name is required',
   'Question text is required' : 'Question text is required',
   'Question help text is required': 'Question help text is required',
   'At least one Question Topic is required': 'At least one Question Topic is required',
   'Question Type is required': 'Question Type is required',
   'Language is required': 'Language is required',
   'The Topic ' : 'The Topic',
   ' is already added. Please select from the list or add a new topic.' : 'is already added. Please select from the list or add a new topic.',
   'Answers' : 'Answers',
   'Answer' : 'Answer',
   'Question name' : 'Question name',
   'Question text' : 'Question text',
   'Question Help Text' : 'Question Help Text',
   'Question Type' : 'Question Type',
   'Question Topic' : 'Question Topic',
   'Add Topic' : 'Add Topic',
   'Points' : 'Points',
   'Answer is required' : 'Answer is required',
   'Single-select' : 'Single-select',
   'Multi-select' : 'Multi-select',
   'single-select' : 'Single-select',
   'multiple-select' : 'Multi-select',

   /****************** Quiz *************/

   'Quiz id' : 'Quiz id',
   'Add Quiz' : 'Add Quiz',
   'Edit Quiz' : 'Edit Quiz',
   'Quiz name' : 'Quiz name',
   'Quiz ' : 'Quiz ',
   'Select Questions' : 'Select Questions',
   'Passing Percent(%)' : 'Passing Percent(%)',
   'The value must be a positive number and less than or equal to ' : 'The value must be a positive number and less than or equal to ',
   'The value must be less than or equal to ' : 'The value must be less than or equal to ',
   'Is Randomised' : 'Is Randomised',
   'Question Count' : 'Question Count',
   'Questions Selected' : 'Questions Selected',
   'Is Mandatory' : 'Is Mandatory',
   'Topic' : 'Topic',
   'Order Index' : 'Order Index',
   'Quiz image' : 'Quiz image',
   'Quiz Language' : 'Quiz Language',
   'Quiz Type' : 'Quiz Type',
   'Quiz name is required' : 'Quiz name is required',
   'Quiz Type is required' : 'Quiz Type is required',
   'Passing Percent is required' : 'Passing Percent is required',
   'The value must be a positive number' : 'The value must be a positive number',
   'Has Randomized Subset' : 'Has Randomized Subset',
   'Randomized Question Count' : "Randomized Question Count",
   'Quiz contains a total of ' : 'Quiz contains a total of ',
   ' Question. Out of which ' : ' Question. Out of which ',
   ' Questions. Out of which ' : ' Questions. Out of which ',
   ' Question will be shown, ' : ' Question will be shown, ',
   ' Questions will be shown, ' : ' Questions will be shown, ',
   ' is a Mandatory Question and ' : ' is a Mandatory Question and ',
   ' are Mandatory Questions and ' : ' are Mandatory Questions and ',
   ' no ' : ' no ',
   ' Question is randomized. ' : ' Question is randomized. ',
   ' Questions are randomized. ' : ' Questions are randomized. ',
   'YES' : 'YES',
   'NO' : 'NO',
   'Course is required' : 'Course is required',
   'Select at least one module' : 'Select at least one module',

   'Take Quiz' : 'Take Quiz',
   'Instructions' : 'Instructions',
   'No Quiz to display for this course' : 'No Quiz to display for this course',
   'Quiz Instruction 1' : 'All answers are mandatory to score maximum points.',
   'Quiz Instruction 2' : 'You need to answer all questions inorder to be able to submit the quiz.',
   'Quiz Instruction 3' : 'This Quiz is for Practice purpose only.',
   'Quiz Instruction 4' : 'Practice as many times as possible. Quiz final score does not affect the certification process, but only helps you to prepare well for the certification exam.',
   'Quiz Instruction 5' : 'Percentage of passing is ',
   'Start' : 'Start',
   'Quit' : 'Quit',
   'Result' : 'Result',
   'Results' : 'Results',
   'You scored' : 'You scored',
   'Percent of passing is' : 'Percent of passing is',
   'Take Quiz Again': 'Take Quiz Again',

   'Daily Quiz Instruction 1' : 'All answers are mandatory to score maximum points.',
   'Daily Quiz Instruction 2' : 'You need to answer all questions inorder to be able to submit the quiz.',
   'Daily Quiz Instruction 3' : 'You can take this quiz only once in a day. Quiz final score does not affect the certification process, but only helps you to prepare well for the certification exam.',
   'Daily Quiz Instruction 4' : 'Maximum number of questions for this quiz is ',
   'Daily Quiz Instruction 5' : 'Percentage of passing is ',

   'Quizzes': 'Quizzes',
   'Daily Quiz' : 'Daily Quiz',
   'All Quizzes' : 'All Quizzes',
   'Take Daily Quiz' : 'Take Daily Quiz',
   'No Questions Found for Daily Quiz' : 'No Questions Found for Daily Quiz',
   'Have you subscribed to Courses?' : 'Have you subscribed to Courses?',
   'Have you completed any modules in a course? Does that module have any quiz?' : 'Have you completed any modules in a course? Does that module have any quiz?',
   'Have you completed any Courses? Does that Course have any quiz?' : 'Have you completed any Courses? Does that Course have any quiz?',
   'Has your company configured settings for Daily Quizzes?' : 'Has your company configured settings for Daily Quizzes?',
   'No Quizzes to show' : 'No Quizzes to show',
   'You have already taken the daily quiz' : 'You have already taken the daily quiz',
   
   "Quiz Completed" : "Quiz Completed",
   "Course Completed" : "Course Completed",
   "Module Completed" : "Module Completed",
   "Role Assigned" : "Role Assigned",
   "Role Received" : "Rolle Received",
   "Sets user status to disabled" : "Sets user status to disabled",
   "Status is set to be disabled" : "Status is set to be disabled",
   "Left Group" : "Left Group",
   "Joined Group" : "Joined Group",
   "New" : "New",
   "Internal" : "Internal",
   "Quiz Passed" : "Quiz Passed",
   
   "group": {
      "left": {
         "name": "Left Group",
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "groupName": {
            "key": "Group Name",
            "description": "This describes the name of the group.",
         },
         "groupType": {
            "key": "Group Type",
            "description": "This describes if it is an internal or external group.",
         },
      },
      "joined": {
         "name": "Joined Group",
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "groupName": {
            "key": "Group Name",
            "description": "This describes the name of the group.",
         },
         "groupType": {
            "key": "Group Type",
            "description": "This describes if it is an internal or external group.",
         },
      },
   },
   "course": {
      "completed": {
         "status": {
            "key": "Status",
            "description": "This is the course status.",
         },
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "courseName": {
            "key": "Course Name",
            "description": "This describes the name of the course.",
         },
         "relatedModules": {
            "key": "Related Modules",
            "description": "This describes the modules that are related with the course.",
         },
         "courseDescription": {
            "key": "Course Description",
            "description": "This describes the description of the course.",
         },
      },
   },
   "module": {
      "completed": {
         "score": {
            "key": "Score",
            "description": "This describes the module specific score.",
         },
         "status": {
            "key": "Status",
            "description": "This describes the module status.",
         },
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "relatedCourses":{
            "key": "Related Courses",
            "description": "These are the courses to which the module is associated with.",
         },
         "timeSpent": {
            "key": "Time Spent",
            "description": "This describes the time the user has spent in the module.",
         },
         "moduleName": {
            "key": "Module Name",
            "description": "This describes the module name.",
         },
         "relatedCourse": {
            "key": "Related Course Name",
            "description": "This describes the course which this module is part of.",
         },
         "totalAttempts": {
            "key": "Total Attempts",
            "description": "This describes the number of total attempts the user took to complete the module.",
         },
         "moduleDescription": {
            "key": "Module Description",
            "description": "This is the module description.",
         },
         "moduleVersionNo": {
            "key": "Module Version No",
            "description": "This describes the version number of the module.",
         },
         "scoreInPercentage": {
            "key": "Score In Percentage",
            "description": "This describes the score of the module in percent.",
         },
         "moduleVersionType": {
            "key": "Module Version Type",
            "description": "This describes the type of the module version.",
         },
      },
   },
   "quiz": {
      "completed": {
         "quizName": {
            "key": "Quiz Name",
            "description": "This is the quiz name.",
         },
         "quizDescription": {
            "key": "Quiz Description",
            "description": "This is a description of the quiz.",
         },
         "quizType": {
            "key": "Quiz Type",
            "description": "This describes the type of the quiz.",
         },
         "links": {
            "key": "Links",
            "description": "These are the links to the related quizzes.",
         },
         "score": {
            "key": "Score",
            "description": "This is the quiz score.",
         },
         "status": {
            "key": "Status",
            "description": "This describes the quiz status.",
         },
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "scoreInPercentage": {
            "key": "Score In Percentage",
            "description": "This is the quiz score in percentage.",
         },
      },
      "passed" :{
         "https://learninglocker&46;net/result-duration": {
            "seconds": {
               "key": "Time Duration",
               "description": "This is the amount of time took to complete Quiz.",
            },
         },
         "quiz_id": {
            "key": "Quiz Id",
            "description": "This is the quiz Id.",
         },
         "sendStatement": {
            "key": "Send Statement",
            "description": "This sends the statement",
         },
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
      },
   },
   "permission": {
      "assigned": {
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "recipient": {
            "key": "Recipient",
            "description": "This describes the recipient of the permission.",
         },
         "customRoles": {
            "key": "Custom Roles",
            "description": "This describes the list of custom roles.",
         },
         "permissions": {
            "key": "Permissions",
            "description": "This describes the related permissions.",
         },
      },
      "received": {
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "assignedBy": {
            "key": "Assigned By",
            "description": "This describes the assigner.",
         },
         "customRoles": {
            "key": "Custom Roles",
            "description": "This describes the list of custom roles.",
         },
         "permissions": {
            "key": "Permissions",
            "description": "This describes the related permissions.",
         },
      },
   },
   "status": {
      "disabled": {
         "logType": {
            "key": "Log Type",
            "description": "This describes the type of event.",
         },
         "disabledBy": {
            "key": "Disabled By",
            "description": "This is the user that cariied the disable action.",
         },
         "disabledUser": {
            "key": "Disabled User",
            "description": "This is the user to get disabled.",
         },
         "disableFromDate": {
            "key": "Disabled From Date",
            "description": "This is the date set to disabled the user.",
         },
      },
   },


   'You need to complete previous modules' : 'You need to complete previous modules',
   'User Documents': 'User Documents',
   'User Activity': 'User Activity',
   'Filter By': 'Filter By',
   'Inverse Timeline': 'Inverse Timeline',
   'View Details': 'View Details',
   'Key': 'Key',
   'Value': 'Value',
   'No Activity to Show': 'No Activity to Show',

   "Custom Email Template" : "Custom Email Template",
   "Use these placeholders while constructing Email" : "Use these placeholders while constructing Email",
   "Email template" : "Email template",
   "Send Test Mail" : "Send Test Mail",
   "Copied to Clipboard" : "Copied to Clipboard",

   "System Emails" : "System Emails",
   "Scheduled Mails" : "Scheduled Mails",
   "Trigger Mails" : "Trigger Mails",
   "Reminder Mails" : "Reminder Mails",

   "System Email Template" : "System Email Template",
   "Email Template id" : "Email Template id",
   "Template Name" : "Template Name",
   "Select Frequency" : "Select Frequency",
   "Frequency" : "Frequency",
   "Start Date" : "Start Date",
   "Start Time" : "Start Time",
   "Scheduled Email Notifications" : "Scheduled Email Notifications",
   "Select Recipient Type" : "Select Recipient Type",
   "Scheduler Settings" : "Scheduler Settings",
   "Time" : "Time",
   "Cycles" : "Cycles",
   "Total Cycles" : "Total Cycles",
   "From Cycle" : "From Cycle",
   "To Cycle" : "To Cycle",
   "Campaign? Yes": "Campaign? Yes",
   "Campaign? No": "Kampagne? No",
   "Placeholders" : "Placeholders",
   "You can choose these placeholders while constructing Email" : "You can choose these placeholders while constructing Email",
   "Copied to Clipboard!" : "Copied to Clipboard!",
   "Subject in" : "Subject in",
   "Custom Email Subject" : "Subject",
   "Send" : "Send",
   "Enter Mail" : "Enter Mail",
   "Recipient is required" : "Recipient is required",
   "Frequency is required" : "Frequency is required",
   "Mail Cycle Count is Over. Increase Cycle Count if you want to keep sending mails" : "Mail Cycle Count is Over. Increase Cycle Count if you want to keep sending mails",
   "Mail Sent! Please check email" : "Mail Sent! Please check email",
   "You need to fill the at least one language, Email Subject and Email Body" : "You need to fill the at least one language, Email Subject and Email Body",
   "Notification Template created successfully" : "Notification Template created successfully",
   "Email Notification successfully Updated" : "Email Notification successfully Updated",
   "Add Cycle Count, If you want Endless Cycle set value to 0." : "Add Cycle Count, If you want Endless Cycle set value to 0.",
   "Subject in German" : "Subject in German",
   "Subject in English" : "Subject in English",
   "Email in German" : "Email in German",
   "Email in English" : "Email in English",
   "Add Template" : "Add Template",
   "Select Mail Template" : "Select Mail Template",
   "Company Language is required" : "Company Language is required",
   "Daily" : "Daily",
   "Weekly" : "Weekly",
   "Monthly" : "Monthly",
   "Yearly" : "Yearly",
   "daily" : "Daily",
   "weekly" : "Weekly",
   "monthly" : "Monthly",
   "yearly" : "Yearly",

   "Triggered Mail Templates" : "Triggered Mail Templates",
   "Trigger Event" : "Trigger Event",
   "Due Days" : "Due Days",
   "Trigger Time" : "Trigger Time",
   "Triggered Email Template" : "Triggered Email Template",
   "Trigger Email Event Settings" : "Trigger Email Event Settings",
   "Add Due Days Count, Email will be sent Due days Before Due Date." : "Add Due Days Count, Email will be sent Due days Before Due Date.",
   "Timezone" : "Timezone",
   "No placeholders available" : "No placeholders available",
   "Inbox Documents" : "Inbox Documents",
   "Course Subscriptions Ending" : "Course Subscriptions Ending",
   "Send After" : "Send After",

   "Reminder Event" : "Reminder Event",
   "Reminder After Every" : "Reminder After Every",
   "Reminder name" : "Reminder name",
   "Reminder Settings" : "Reminder Settings",
   "Remind After Every" : "Remind After Every",
   "Days" : "Days",
   "Signup" : "Signup",
   "signup" : "Signup",
   "Initialize Inbox Documents" : "Initialize Inbox Documents",
   "initialize_inbox_document" : "Initialize Inbox Documents",
   "Please Enter the number of days you want to send the Reminder" : "Please Enter the number of days you want to send the Reminder",

   'Course Statistics' : 'Course Statistics',
   'Per Course' : 'Per Course',
   'Per User' : 'Per User',
   'Active Subscribers' : 'Active Subscribers',
   'Course Modules' : 'Course Modules',
   'Learning Progress of Users' : 'Learning Progress of Users',
   'Passed Percentage of Currently Subscribed Users' : 'Passed Percentage of Currently Subscribed Users',
   'Pass activity over time' : 'Pass activity over time',
   'Number of Users' : 'Number of Users',
   'Percentage Of Course Completed' : 'Percentage Of Course Completed',
   'Average Time Spent' : 'Average Time Spent',
   'No Time Spent' : 'No Time Spent',
   'Average Number Of Attempts to Complete' : 'Average Number Of Attempts to Complete',
   'Not Attempted' : 'Not Attempted',
   'Subscribed Users Learning Status' : 'Subscribed Users Learning Status',
   'Number of active subscribers' : 'Number of active subscribers',
   'Total Number of Modules' : 'Total Number of Modules',
   'Number of users subscribed since first publishing' : 'Number of users subscribed since first publishing',
   'Not Passed' : 'Not Passed',
   'Started' : 'Started',
   'Not Started' : 'Not Started',
   'Finished' : 'Finished',
   'Pass Activity of Users in Weeks' : 'Pass Activity of Users in Weeks',
   'Weeks To Pass' : 'Weeks To Pass',

   'User Statistics' : 'User Statistics',
   'Courses Subscribed' : 'Courses Subscribed',
   'Number of Courses Subscribed' : 'Number of Courses Subscribed',
   'Active Courses' : 'Active Courses',
   'Number of Active Courses' : 'Number of Active Courses',
   'Course Progress' : 'Course Progress',
   'Pass Percentage of currently Subscribed Courses' : 'Pass Percentage of currently Subscribed Courses',
   'Status of learning progress' : 'Status of learning progress',
   'Number of Courses' : 'Number of Courses',
   'Learning Progress in Percentage' : 'Learning Progress in Percentage',
   'All Users loaded' : 'All Users loaded',
   'Module Progress' : 'Module Progress',
   'Module Attempts' : 'Module Attempts',
   'No Attempts' : 'No Attempts',

   'Group Statistics' : 'Group Statistics',
   'Documents' : 'Documents',
   'Equipment Items' : 'Equipment Items',
   'Number of users in Group' : 'Number of users in Group',
   'Number of documents managed through Group' : 'Number of documents managed through Group',
   'Number of tasks managed through Group' : 'Number of tasks managed through Group',
   'Number of equipment managed through Group' : 'Number of equipment managed through Group',
   'Group Admin' : 'Group Admin',
   'Details of Group Admin' : 'Details of Group Admin',
   'Breached Documents' : 'Breached Documents',
   'Number and details of breached Documents' : 'Number and details of breached Documents',
   'Current Status of Inbox Process Progress' : 'Current Status of Inbox Process Progress',
   'Well maintained' : 'Well maintained',
   'Yet to setup' : 'Yet to setup',
   'stage_1' : 'Close to Breach',
   'stage_2' : 'Urgent',
   'days overdue' : 'days overdue',
   'Jump to Inbox' : 'Jump to Inbox',

   '2-Step Verification' : '2-Step Verification',
   'Enter the 6 digit code that we sent to your email address to finish setting up two-factor authentication.' : 'Enter the 6 digit code that we sent to your email address to finish setting up two-factor authentication.',
   'Token' : 'Token',
   'Back' : 'Back',
   'Token is required' : 'Token is required',
   'Invalid two factor auth code' : 'Invalid two factor auth code',

   'question-key' : 'Question',
   'quiz-key' : 'Quiz',
   'custom-role-key' : 'Custom Role',
   'user-key' : 'User',
   'custom-email-scheduling-key' : 'Custom Email Scheduling',
   'group-key' : 'Group',
   'personal-template-key' : 'Personal template',
   'additional-pages-key' : 'Additional Pages',
   'equipment-template-key' : 'Equipment Template',
   'equipment-group-key' : 'Equipment Group',
   'equipment-key' : 'Equipment',
   'test-case-template-key' : 'Test Case Template',
   'test-case-group-key' : 'Test Case Group',
   'test-case-key' : 'Test Case',
   'statistics-key' : 'Statistics',
   'inbox-key' : 'Inbox',

   'can-create-question-key' : 'can-create-question',
   'can-update-question-key' : 'can-update-question',
   'can-delete-question-key' : 'can-delete-question',
   'can-create-quiz-key' : 'can-create-quiz',
   'can-update-quiz-key' :  'can-update-quiz',
   'can-delete-quiz-key' : 'can-delete-quiz',
   'can-create-custom-role-key' : 'can-create-custom-role',
   'can-update-custom-role-key' : 'can-update-custom-role',
   'can-delete-custom-role-key' : 'can-delete-custom-role',
   'can-assign-custom-role-key' : 'can-assign-custom-role',
   'can-audit-user-history-key' : 'can-audit-user-history',
   'can-send-receive-messages-key' : 'can-send-receive-messages',
   'has-access-to-all-mail-types-key' : 'has-access-to-all-mail-types',
   'has-access-to-system-mails-key' : 'has-access-to-system-mails',
   'has-access-to-scheduled-mails-key' : 'has-access-to-scheduled-mails',
   'has-access-to-trigger-mails-key' : 'has-access-to-trigger-mails',
   'has-access-to-reminder-mails-key' : 'has-access-to-reminder-mails',
   'can-create-group-key' : 'can-create-user-groups',
   'can-update-group-key' : 'can-update-user-groups',
   'can-delete-group-key' : 'can-delete-user-groups',
   'can-create-personal-template-key' : 'can-create-personal-template',
   'can-update-personal-template-key' : 'can-update-personal-template',
   'can-delete-personal-template-key' : 'can-delete-personal-template',
   'has-access-to-additional-pages-key' : 'has-access-to-additional-pages',
   'has-access-to-additional-pages-resource-key' : 'has-access-to-additional-pages-resource',
   'can-create-equipment-template-key' : 'can-create-equipment-template',
   'can-update-equipment-template-key' : 'can-update-equipment-template',
   'can-delete-equipment-template-key' : 'can-delete-equipment-template',
   'can-create-equipment-key' : 'can-create-equipment',
   'can-update-equipment-key' : 'can-update-equipment',
   'can-delete-equipment-key' : 'can-delete-equipment',
   'can-create-equipment-group-key' : 'can-create-equipment-group',
   'can-update-equipment-group-key' : 'can-update-equipment-group',
   'can-delete-equipment-group-key' : 'can-delete-equipment-group',
   'can-create-test-case-template-key' : 'can-create-test-case-template',
   'can-update-test-case-template-key' : 'can-update-test-case-template',
   'can-delete-test-case-template-key' : 'can-delete-test-case-template',
   'can-create-test-case-group-key' : 'can-create-test-case-group',
   'can-update-test-case-group-key' : 'can-update-test-case-group',
   'can-delete-test-case-group-key' : 'can-delete-test-case-group',
   'can-create-test-case-key' : 'can-create-test-case',
   'can-update-test-case-key' : 'can-update-test-case',
   'can-delete-test-case-key' : 'can-delete-test-case',
   'has-access-to-all-statistics-key' : 'has-access-to-all-statistics',
   'has-access-to-pending-exercise-key' : 'has-access-to-pending-exercise',
   'has-access-to-register-participation-key' : 'has-access-to-register-participation',
   
   'can-create-question-val' : 'Users with this permission are allowed to create new Questions',
   'can-update-question-val' : 'Users with this permission are allowed to update existing Questions',
   'can-delete-question-val' : 'Users with this permission are allowed to delete Questions',
   'can-create-quiz-val' : 'Users with this permission are allowed to create new Quizzes',
   'can-update-quiz-val' :  'Users with this permission are allowed to update existing Quizzes',
   'can-delete-quiz-val' : 'Users with this permission are allowed to delete Quizzes',
   'can-create-custom-role-val' : 'Users with this permission are allowed to create new Custom Roles',
   'can-update-custom-role-val' : 'Users with this permission are allowed to update existing Custom Roles',
   'can-delete-custom-role-val' : 'Users with this permission are allowed to delete Custom Roles',
   'can-assign-custom-role-val' : 'Users with this permission are allowed to assign Custom Roles to User',
   'can-audit-user-history-val' : 'Users with this permission are allowed to view Auditing History of User',
   'can-send-receive-messages-val' : 'Users with this permission can send and receive messages to users with same permissions set',
   'has-access-to-all-mail-types-val' : 'Users with this permission can create, modify delete all mail types.',
   'has-access-to-system-mails-val' : 'Users with this permission can create, edit, view and delete System Emails',
   'has-access-to-scheduled-mails-val' : 'Users with this permission can create, edit, view and delete Scheduled Emails',
   'has-access-to-trigger-mails-val' : 'Users with this permission can create, edit, view and delete Trigger Emails',
   'has-access-to-reminder-mails-val' : 'Users with this permission can create, edit, view and delete Reminder Emails',
   'can-create-group-val' : 'Users with this permission are allowed to create User Groups',
   'can-update-group-val' : 'Users with this permission are allowed to update User Groups',
   'can-delete-group-val' : 'Users with this permission are allowed to delete User Groups',
   'can-create-personal-template-val' : 'Users with this permission are allowed to create Personal Templates',
   'can-update-personal-template-val' : 'Users with this permission are allowed to update Personal Templates',
   'can-delete-personal-template-val' : 'Users with this permission are allowed to delete Personal Templates',
   'has-access-to-additional-pages-val' : 'Users with this permission can create, edit, delete Additional Pages',
   'has-access-to-additional-pages-resource-val' : 'Users with this permission can create, delete Additional Pages Resources',
   'can-create-equipment-template-val' : 'Users with this permission are allowed to create Equipment Template',
   'can-update-equipment-template-val' : 'Users with this permission are allowed to update Equipment Template',
   'can-delete-equipment-template-val' : 'Users with this permission are allowed to delete Equipment Template',
   'can-create-equipment-val' : 'Users with this permission are allowed to create Equipment',
   'can-update-equipment-val' : 'Users with this permission are allowed to update Equipment',
   'can-delete-equipment-val' : 'Users with this permission are allowed to delete Equipment',
   'can-create-equipment-group-val' : 'Users with this permission are allowed to create Equipment Group',
   'can-update-equipment-group-val' : 'Users with this permission are allowed to update Equipment Group',
   'can-delete-equipment-group-val' : 'Users with this permission are allowed to delete Equipment Group',
   'can-create-test-case-template-val' : 'Users with this permission are allowed to create Test Case Template',
   'can-update-test-case-template-val' : 'Users with this permission are allowed to update Test Case Template',
   'can-delete-test-case-template-val' : 'Users with this permission are allowed to delete Test Case Template',
   'can-create-test-case-group-val' : 'Users with this permission are allowed to create Test Case Group',
   'can-update-test-case-group-val' : 'Users with this permission are allowed to update Test Case Group',
   'can-delete-test-case-group-val' : 'Users with this permission are allowed to delete Test Case Group',
   'can-create-test-case-val' : 'Users with this permission are allowed to create Test Case',
   'can-update-test-case-val' : 'Users with this permission are allowed to update Test Case',
   'can-delete-test-case-val' : 'Users with this permission are allowed to delete Test Case',
   'has-access-to-all-statistics-val' : 'Users with this permission are allowed access to Course and Group Statistics',
   'has-access-to-pending-exercise-val' : 'Users with this permission can grade users for Exercises submitted',
   'has-access-to-register-participation-val' : 'Users with this permission can confirm the participation of users for Events',
   
   'can-create-question' : 'can-create-question',
   'can-update-question' : 'can-update-question',
   'can-delete-question' : 'can-delete-question',
   'can-create-quiz' : 'can-create-quiz',
   'can-update-quiz' :  'can-update-quiz',
   'can-delete-quiz' : 'can-delete-quiz',
   'can-create-custom-role' : 'can-create-custom-role',
   'can-update-custom-role' : 'can-update-custom-role',
   'can-delete-custom-role' : 'can-delete-custom-role',
   'can-assign-custom-role' : 'can-assign-custom-role',
   'can-audit-user-history' : 'can-audit-user-history',
   'has-access-to-system-mails' : 'has-access-to-system-mails',

   'Custom Roles' : 'Custom Roles',
   'Custom Role' : 'Custom Role',
   'Custom Role Name' : 'Custom Role Name',
   'Permissions' : 'Permissions',
   'Add Custom Role' : 'Add Custom Role',
   'Edit Custom Role' : 'Edit Custom Role',
   'Custom Role name' : 'Custom Role Name',
   'Permission Labels' : 'Permission Labels',
   'Select Permission' : 'Select Permission',
   'Custom Role Name is required' : 'Custom Role Name is required',

 /****************** User Details *************/

   'User Details' : 'User Details',
   'Full Name' : 'Full Name',
   'E-Mail' : 'Full Name',
   'Phone' : 'Phone',
   'Status Details' : 'Status Details',
   'Subscribed Courses Details' : 'Subscribed Courses Details',
   'Join Date' : 'Join Date',
   'Last Login' : 'Last Login',

 /****************** New Dashboard *************/

   'Welcome' : 'Welcome',
   'Continue Learning' : 'Continue Learning',
   'Users Logged In' : 'Users Logged In',
   'Last Logged In' : 'Last Logged In',
   'Last Session' : 'Last Session',
   'The day you last logged in' : 'The day you last logged in',
   'Courses that you have subscribed to' : 'Courses that you have subscribed to',
   'Number of documents expired. Please update your documents' : 'Number of documents expired. Please update your documents',
   'Last Courses Visited' : 'Last Courses Visited',
   'Not Logged' : 'Not Logged',
   
 /****************** New Courses *************/
      
   'Course Details' : 'Course Details',
   'Resume Learning' : 'Resume Learning',
   'Your have already taken the daily quiz' : 'Your have already taken the daily quiz',
   'Ends' : 'Ends',

   /****************** Messages *************/
   'Messages' : 'Messages',
   'Date' : 'Date',
   'Read' : 'Read',
   'Unread' : 'Unread',

 /****************** Additional Pages *************/
   'Resources' : 'Resources',
   'Resource Id' : 'Resource Id',
   'Resource Type' : 'Resource Type',
   'File' : 'File',
   'Add Resources' : 'Add Resources',
   'Resource Name' : 'Resource Name',
   'Image Upload' : 'Image Upload',
   'Video Resource Link' : 'Video Resource Link',
   'Additional Pages' : 'Additional Pages',
   'Additional Pages - Resources' : 'Additional Pages - Resources',
   'Page Id' : 'Page Id',
   'Page Name' : 'Page Name',
   'Page Name in English' : 'Page Name in English',
   'Page Name in German' : 'Page Name in German',
   '*Changes will reflect only after you logout' : '*Änderungen werden erst wirksam, nachdem Sie sich abgemeldet haben',
   'Page Type' : 'Page Type',
   'Blank Page' : 'Blank Page',
   'Glossary Page' : 'Glossary Page',
   'FAQ Page' : 'FAQ Page',
   'Display on Side Menu?' : 'Display on Side Menu?',
   'Title in English' : 'Title in English',
   'Title in German' : 'Title in German',
   'Page Contents in English' : 'Page Contents in English',  
   'Page Contents in German' : 'Page Contents in German',  
   'Glossary Term in English' : 'Glossary Term in English',
   'Glossary Term in German' : 'Glossary Term in German',
   'Definition in English' : 'Definition in English',
   'Definition in German' : 'Definition in German',
   'Faq Question in English' : 'Faq Question in English',
   'Faq Question in German' : 'Faq Question in German',
   'Answer in English' : 'Answer in English',
   'Answer in German' : 'Answer in German',
   'Attach Resource' : 'Attach Resource',
   'Add Resource' : 'Add Resource',
   'New Resource' : 'New Resource',   
   'Page name is required' : 'Page name is required',
   'Page Type is required' : 'Page Type is required',
   'Resource Type is required' : 'Resource Type is required',
   'You cannot add more than 15 templates' : 'You cannot add more than 15 templates',
   'Image Resources fetched' : 'Image Resources fetched',
   'Select Resource' : 'Select Resource',
   'Please check if you have filled Page Names in all Languages and filled in at least one Title and Page content for respective Language.' : 'Please check if you have filled Page Names in all Languages and filled in at least one Title and Page content for respective Language.',
   'You need to fill Page Names in all Languages.' : 'You need to fill Page Names in all Languages.',
   'You need to fill the at least one language, Title and Page Contents' : 'You need to fill the at least one language, Title and Page Contents',
   'faq' : 'FAQ',
   'glossary' : 'Glossary',
   'blank' : 'Blank Page',

 /****************** Survey *************/
   "Survey" : "Survey",
   "Surveys" : "Surveys",
   "Take Survey" : "Take Survey",
   "No Survey Found for this Course!" : "No Survey Found for this Course!",
   "This survey is already taken. Thank you for your feedback!" : "This survey is already taken. Thank you for your feedback!",
   'Survey was submitted successfully!' : 'Survey was submitted successfully!',


   'Take Test' : 'Take Test',
   'You need to pass a module before taking test!' : 'You need to pass a module before taking test!',
   'You already passed test!' : 'You already passed test!',
   'If you want to check your test history, Click here' : 'If you want to check your test history, Click here',
   'Jump to Test Center' : 'Jump to Test Center',
   'Please wait until the timeout is over.' : 'Please wait until the timeout is over.',
   'Test is already running!' : 'Test is already running!',
   'Invalid input!' : 'Invalid input!',
   'Test Instruction 1' : 'All answers are mandatory to score maximum points.',
   'Test Instruction 2' : 'Duration for this test is ',
   ' Minutes' : 'Test',
   'Test Instruction 3' : 'Percentage of passing is ',
   'Test Instruction 4' : 'You will have to wait for ',
   'Test Instruction 5' : ' minutes, to take the etst again if you fail the test',
   'Test Instruction 6' : ' There is no time limit for this test',
   'Test Instruction 7' : ' There is no timeout for this test',
   'Test History' : 'Test History',
   'Attempt' : 'Attempt',
   'Test Taken on' : 'Test Taken on',
   'Scored Percentage' : 'Scored Percentage',
   'Test Name' : 'Test Name',

   'Test-center' : 'Test-center',
   'Test Center' : 'Test Center',
   'Test Results' : 'Test Results',
   'PASSED' : 'PASSED',
   'FAILED' : 'FAILED',

   //Exams
   'Exam' : 'Exam',
   'Exams' : 'Exams',
   'Exam Ready' : 'Exam Ready',
   'Take Exam' : 'Take Exam',
   'Exam Taken on' : 'Exam Taken on',
   'Exam History' : 'Exam History',
   'If you want to check history, Click here' : 'If you want to check history, Click here',
   'Reply' : 'Reply',
   'Exam Results' : 'Exam Results',
   'Exam Name' : 'Exam Name',

   //Exercise
   'Exercise' : 'Exercise',
   'Exercises' : 'Exercises',
   'Download Exercise' : 'Download Exercise',
   'Download Exercise Question' : 'Download Exercise Question',
   'Close & come back later' : 'Close & come back later',
   'Upload Exercise Answer' : 'Upload Exercise Answer',
   'You have already uploaded the exercise. You will receive results once a examiner grades your exercise' : 'You have already uploaded the exercise. You will receive results once a examiner grades your exercise',
   'Pending Exercise' : 'Pending Exercise',
   'Uploaded By User' : 'Uploaded By User',
   'Course Expires on' : 'Course Expires on',
   'Grade' : 'Grade',
   'File Uploaded' : 'File Uploaded',
   'Pending Exercises (Mandatory)' : 'Pending Exercises (Mandatory)',
   'Pending Exercises (Training)' : 'Pending Exercises (Training)',
   'Comments' : 'Comments',
   'Please enter your comments' : 'Please enter your comments',
   'FAIL' : 'FAIL',
   'PASS' : 'PASS',
   'Uploaded Answers' : 'Uploaded Answers',
   'No comments added' : 'No comments added',
   'Not yet graded' : 'Not yet graded',
   'Next' : 'Next',
   'Comment' : 'Comment',
   'This Exercise is already graded' : 'This Exercise is already graded',
   '*You ( ' : '*You ( ',
   ') are grading this exercise as ' : ') are grading this exercise as ',
   'Exercise was graded successfully!' : 'Exercise was graded successfully!',
   'Close / Grade later' : 'Close / Grade later',
   'Exercise Results (Mandatory)' : 'Exercise Results (Mandatory)',
   'Exercise Results (Training)' : 'Exercise Results (Training)',
   'Exercise Name' : 'Exercise Name',
   'Exercise Description' : 'Exercise Description',
   'Date Last Taken' : 'Date Last Taken',
   'Date taken' : 'Date taken',
   'Date graded' : 'Date graded',
   'Graded By' : 'Graded By',
   'Examiner Email' : 'Examiner Email',

   //Calendar
   'Calendar' : 'Calendar',
   'Calendars' : 'Calendars',
   'Today' : 'Today',
   'Day' : 'Day',
   'Week' : 'Week',
   'Month' : 'Month',
   '4 days' : '4 days',
   'You are viewing an expired event!' : 'You are viewing an expired event!',
   'ACCEPTED' : 'ACCEPTED',
   'DECLINED' : 'DECLINED',
   'Join' : 'Join',
   'Thank you for joining the event. An invitation has been send to your e-mail address.' : 'Thank you for joining the event. An invitation has been send to your e-mail address.',
   'Reload Calendar' : 'Reload Calendar',
   'Loading Events. Please stand by...' : 'Loading Events. Please stand by...',
   'Events' : 'Events',
   'Personal Calendar' : 'Personal Calendar',
   'Cancel Participation' : 'Cancel Participation',
   'Add Participant limit' : 'Add Participant limit',
   'You have joined this event. Below are details of the event.' : 'You have joined this event. Below are details of the event.',
   'Register Participation' : 'Register Participation',
   'Register Participation of Users' : 'Register Participation of Users',
   'Upcoming Events' : 'Upcoming Events',
   'Next Event on your calendar' : 'Next Event on your calendar',
   'Expires on:' : 'Expires on:',
   'This exam is Locked. Complete all modules in the course, tests, exercises, events to unlock this exam.' : 'This exam is Locked. Complete all modules in the course, tests, exercises, events to unlock this exam.',

   
};